module.exports = __webpack_public_path__ + "img/Icon_search.72cc9f0b.png";